import { 
  SET_MATERIAL_NAMES, 
  SET_PROFILE_SHAPE, 
  SET_PROFILE_SIZES, 
  SET_PROFILE_TYPES, 
  SET_SPINNER,
  RESET_PROFILE_STATE,
  SET_PROFILE_STATE } from '@reducers/web-services/profile/actions';
import { APP_TYPES } from '@config';
import { mergeDeep } from '@services/helper.service';
import { brandList } from './../../../app.values';

// 0 - EU, 1 - AISC, 2 - ANZ 
export const defaultProfileState = {
  [APP_TYPES.GENERAL_CALCULATION]: [
    {
      family: 'HEA nach DIN',
      size: 'HEA180',
    },
    {
      family: 'AISC S Shape',
      size: 'S3X7.5',
    },
    {
      family: 'AS-NZS Universal Beam',
      size: 'UB 150x14.0',
    },
    {
      family: 'None', // 3 - special case for Masonry
    }
  ],
  [APP_TYPES.BRACKET_ATTACHMENT]: [
    {
      family: 'HEA nach DIN',
      size: 'HEA180',
    },
    {
      family: 'AISC S Shape',
      size: 'S3X7.5',
    },
    {
      family: 'AS-NZS Universal Beam',
      size: 'UB 150x14.0',
    }
  ],
  [APP_TYPES.SAFETY_BARRIER]: [
    {
      family: 'Flat nach DIN',
      size: 'FL50X12',
    },
    {
      family: 'AISC Flat',
      size: 'Flat 5/8X1 3/8',
    },
    {
      family: 'AS-NZS Rectangular Hollow Section - CF',
      size: 'RHS 50x25x2.0',
    }
  ],
};

export const defaultMaterialState = {
  [brandList.Spit]: {
    [APP_TYPES.GENERAL_CALCULATION]: 'S235',
    [APP_TYPES.BRACKET_ATTACHMENT]: 'S235',
    [APP_TYPES.SAFETY_BARRIER]: 'S235'
  },
  [brandList.Redhead]: {
    [APP_TYPES.GENERAL_CALCULATION]: 'S235',
    [APP_TYPES.BRACKET_ATTACHMENT]: 'S235',
    [APP_TYPES.SAFETY_BARRIER]: 'S235'
  },
  [brandList.Ramset]: {
    [APP_TYPES.GENERAL_CALCULATION]: 'ANZ350',
    [APP_TYPES.BRACKET_ATTACHMENT]: 'ANZ350',
    [APP_TYPES.SAFETY_BARRIER]: 'ANZ350'
  },
  [brandList.Sea]: {
    [APP_TYPES.GENERAL_CALCULATION]: 'S235',
    [APP_TYPES.BRACKET_ATTACHMENT]: 'S235',
    [APP_TYPES.SAFETY_BARRIER]: 'S235'
  },
};

const initState = {
  materialNames: [],
  profileTypes: [],
  profileSizes: [],
  profileShape: null,
  isPending: true,
};

const profile = (state = initState, action) => {
  switch (action.type) {    
    case RESET_PROFILE_STATE: {
      return initState;
    }
    case SET_PROFILE_STATE: {
      return action.state;
    }
    case SET_MATERIAL_NAMES: {
      state.materialNames = action.value;

      return mergeDeep({}, state);
    }
    case SET_PROFILE_TYPES: {
      // state.profileTypes = action.value;

      return mergeDeep({}, state, {
        profileTypes: action.value
      });
    }
    case SET_PROFILE_SIZES: {
      // state.profileSizes = action.value;

      return mergeDeep({}, state, {
        profileSizes: action.value
      });
    }
    case SET_PROFILE_SHAPE: {
      state.profileShape = null;

      return mergeDeep({}, state, {
        profileShape: action.value
      });
    }
    case SET_SPINNER: {
      return mergeDeep({}, state, {
        isPending: action.isSpinning
      });
    }
    default: {
      return state;
    }
  }
};

export default profile;



// WEBPACK FOOTER //
// ./src/reducers/web-services/profile/index.js